import SeracGlyph, { type SeracGlyphVariant } from './SeracGlyph';

interface SeracWordmarkProps {
  size?: number;
  accent?: string;
  variant?: SeracGlyphVariant | 'none';
}

export default function SeracWordmark({
  size = 18,
  accent = 'var(--ice-500)',
  variant = 'strata',
}: SeracWordmarkProps) {
  const showGlyph = variant !== 'none';
  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 8,
        fontFamily: 'var(--font-display)',
        fontWeight: 500,
        fontSize: size,
        letterSpacing: '-0.02em',
        lineHeight: 1,
      }}
    >
      {showGlyph && <SeracGlyph size={size + 2} color={accent} variant={variant as SeracGlyphVariant} />}
      <span>serac</span>
    </span>
  );
}
